import Vue from 'vue'
import VueRouter from 'vue-router'

import { BOverlay, CardPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'

import {BAlert,BButton,BEmbed,BForm,BFormInput,BFormGroup,BFormSelect,BInputGroup,BInputGroupAppend,BIcon,BLink,BListGroup,BListGroupItem,BImg,BSpinner,BTab,BTabs} from 'bootstrap-vue'

Vue.use(VueRouter);
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)

Vue.component('b-alert',BAlert);
Vue.component('b-button',BButton);
Vue.component('b-embed',BEmbed);
Vue.component('b-form',BForm);
Vue.component('b-form-input',BFormInput);
Vue.component('b-form-group',BFormGroup);
Vue.component('b-form-select',BFormSelect);
Vue.component('b-icon',BIcon);
Vue.component('b-link',BLink);
Vue.component('b-list-group',BListGroup);
Vue.component('b-list-group-item',BListGroupItem);
Vue.component('b-img',BImg);
Vue.component('b-input-group',BInputGroup);
Vue.component('b-input-group-append',BInputGroupAppend);
Vue.component('b-overlay',BOverlay);
Vue.component('b-spinner',BSpinner);
Vue.component('b-tab',BTab);
Vue.component('b-tabs',BTabs); 

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/custom.scss'//must be after the bootstrap includes

import App from './App.vue'
import i18n from './common/lang'
import api from './common/Api'

Vue.prototype.$dictionary = i18n();
Vue.prototype.$mobileapi = api();

import AboutUs from './AboutUs.vue'
import Events from './Events.vue'
import Landing from './Landing.vue'
import MakeAppointment from './MakeAppointment.vue'
import Products from './Products.vue'
import ProductDetails from './ProductDetails.vue'
import Team from './Team.vue'
import Employee from './Employee.vue'
const routes = [
  {path: '/appointment', component: MakeAppointment},
  {path: '/about-us', component: AboutUs},
  {path: '/products', component: Products},
  {path: '/products/:category_id', component: ProductDetails},
  {path: '/events', component: Events},
  {path: '/team', component: Team},
  {path: '/team/:employee_id', component: Employee},
  {path: '/', component: Landing}
];
const router = new VueRouter({routes});

new Vue({
  router,
  data: {
    categories: [],//cached product categories
    employees: [],//cached employees
    translations: null,
    assets: null,
    configuration: null,//controls visibility
  },
  computed: {
    lang: function(){
      return navigator.language ? navigator.language.substr(0,2) : 'en';
    }
  },
  render: h => h(App),
}).$mount('#app')
